import { NestedModel } from "../nestedmodel";

/*
 Executing a groovy script:

 const poll = async (data) => {
    if (!has(data, 'taskResultInfo')) {
        return data;
    }
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            console.log('Polling:', data);
            store.acsStore.api.tasks.taskId(data.taskResultInfo.taskId).executeGroovyScript.fetch()
                .then(poll)
                .then(resolve)
                .catch(reject)
        }, data.taskResultInfo.pollIntervalMs);
    });
};

rootStore.acsStore.api.devices.cpeId(cpeId).tasks.executeGroovyScript.save({
    "scriptName": "GetDeviceDataModelInfo",
    "parameterList": [],
    "taskResultTimeoutSecs": 6
})
    .then(poll)
    .then(console.log)
    .catch(console.error)
    .finally((data) => { console.log(data)});

 */

export class Tasks extends NestedModel {
    constructor(props, attributes) {
        super(props, Object.assign({}, attributes));
        this.addObject = new NestedModel({value: 'addObject', parent: this});
        this.getParameterValues = new NestedModel({value: 'getParameterValues', parent: this});
        this.setParameterValues = new NestedModel({value: 'setParameterValues', parent: this});
        this.upload = new NestedModel({value: 'upload', parent: this});
        this.executeGroovyScript = new NestedModel({value: 'executeGroovyScript', parent: this});
        this.deleteObject = new NestedModel({value: 'deleteObject', parent: this});
        this.factoryReset = new NestedModel({value: 'factoryReset', parent: this});
        this.getParameterAttributes = new NestedModel({value: 'getParameterAttributes', parent: this});
        this.setParameterAttributes = new NestedModel({value: 'setParameterAttributes', parent: this});
        this.reboot = new NestedModel({value: 'reboot', parent: this});
        this.download = new NestedModel({value: 'download', parent: this});
        this.featureSetDeviceTask = new NestedModel({value: 'featureSetDeviceTask', parent: this});
        this.cancelTasks = new NestedModel({value: 'cancelTasks', parent: this});
        this.cancelAllTasks = new NestedModel({value: 'cancelAllTasks', parent: this});
    }
}
